<div class="header__cupra">
  <nav class="navbar navbar-expand-lg px-0 py-2 py-md-3">
    <div class="container">
      <a class="navbar-brand" href="https://www.cupraofficial.es/">
        <img class="logo-cupra" src="../../../../assets/images/cupra-logo.svg" width="126px" alt="CUPRA">
      </a>
      <ul class="navbar-nav mt-1">
        <li class="nav-item"><a class="nav-link" href="https://www.cupraofficial.es/">Sitio web CUPRA</a></li>
      </ul>
    </div>
  </nav>
</div>
<div class="header__calculator">
  <div class="container">
    <div class="identity">
      Calcula tu mantemiento
    </div>
    <div class="header__img">
      <img src="../../../../assets/images/header-img.jpg" class="w-100" alt="Matenimiento oficial Cupra">
    </div>
  </div>

  <div class="container">
    <div class="header__title">
      <h1>SERVICIO SIN SORPRESA</h1>
      <div class="description">Tú eliges cuándo vivir aventuras o cuándo quieres tener todo previsto. Con la Calculadora de mantenimiento tendrás de antemano una estimación del coste de las operaciones que necesita tu CUPRA y podrás pedir cita para realizarlas cuando más
        te convenga.</div>
    </div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h2 class="mb-4">CALCULA TU MANTENIMIENTO</h2>
    </div>
  </div>
</div>